import React from 'react';

import { CustomRoute } from 'util/hook/useRouter';
import { appPath } from 'util/routingConfig';

const routes: CustomRoute = {
	path: appPath.adminBicycleBroken.replace(appPath.admin, ''),
	components: () => [import(/* webpackChunkName: 'adminBicycleBroken' */ './component')],
	render: ([AdminBicycleBroken]) => <AdminBicycleBroken />,
};

export default routes;
